// src/setupVideoSync.js
import VideoSyncManager from './managers/VideoSyncManager';

/**
 * Initialize video synchronization system
 * This function should be called once during app startup
 * @returns {Function} Cleanup function to unsubscribe
 */
export const setupVideoSync = () => {
  console.log('Initializing video synchronization system...');
  
  // Subscribe to store changes
  const unsubscribe = VideoSyncManager.subscribeToStore();
  
  // Initial sync with global state
  VideoSyncManager.syncWithGlobalState();
  
  // Set up interval for periodic synchronization
  const syncInterval = setInterval(() => {
    VideoSyncManager.syncWithGlobalState();
  }, 5000); // Every 5 seconds
  
  // Return cleanup function
  return () => {
    clearInterval(syncInterval);
    unsubscribe();
    console.log('Video synchronization system shutdown.');
  };
};

/**
 * Wait for main video player to be ready before starting playback
 * @param {number} timeoutMs - Maximum wait time in milliseconds
 * @returns {Promise<boolean>} - Resolves when ready or timeout
 */
export const waitForMainPlayerReady = (timeoutMs = 5000) => {
  return new Promise((resolve) => {
    let checkCount = 0;
    const maxChecks = 50; // 增加检查次数
    const startTime = Date.now();
    
    const checkReady = () => {
      const videoPlayer = document.querySelector('#videoPlayer video');
      
      // 检查视频元素是否存在且已加载足够数据
      if (videoPlayer && (
        videoPlayer.readyState >= 3 || // HAVE_FUTURE_DATA
        (videoPlayer.readyState >= 2 && videoPlayer.buffered.length > 0) // HAVE_CURRENT_DATA 且有缓冲
      )) {
        console.log('Main video player is ready');
        resolve(true);
        return;
      }
      
      checkCount++;
      const elapsedTime = Date.now() - startTime;
      
      // 如果超过最大检查次数或超时时间，则返回
      if (checkCount >= maxChecks || elapsedTime >= timeoutMs) {
        console.warn(`Timeout waiting for main video player (${elapsedTime}ms)`);
        resolve(false);
        return;
      }
      
      // 使用指数退避策略
      const delay = Math.min(100 * Math.pow(1.2, checkCount), 500);
      setTimeout(checkReady, delay);
    };
    
    checkReady();
  });
};